var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reader" },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    attrs: { readonly: "", id: "linkField" },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend",
                        fn: function() {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", dense: "" },
                                on: { click: _vm.getRegistrationCode }
                              },
                              [_vm._v("Generate")]
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "append-outer",
                        fn: function() {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "secondary", dense: "" },
                                on: { click: _vm.copyLink }
                              },
                              [_vm._v("Copy Link")]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.registrationCode,
                      callback: function($$v) {
                        _vm.registrationCode = $$v
                      },
                      expression: "registrationCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.users,
                      "items-per-page": 15,
                      dense: "",
                      "footer-props": {
                        showFirstLastPage: true,
                        itemsPerPageOptions: [-1, 10, 15, 20, 25],
                        firstIcon: "mdi-arrow-collapse-left",
                        lastIcon: "mdi-arrow-collapse-right",
                        prevIcon: "mdi-minus",
                        nextIcon: "mdi-plus"
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.firstName`,
                          fn: function({ item }) {
                            return [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "editUser",
                                      params: { id: item.id }
                                    },
                                    title: `Edit ${item.firstName} ${item.lastName}`
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.firstName) +
                                      " " +
                                      _vm._s(item.lastName) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: `item.lastLogin`,
                          fn: function({ item }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("luxonSortableDateTime")(
                                      item.lastLogin
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: `item.roles`,
                          fn: function({ item }) {
                            return [
                              _vm._v(" " + _vm._s(item.roles.join()) + " ")
                            ]
                          }
                        },
                        {
                          key: `item.isAccountDisabled`,
                          fn: function({ item }) {
                            return [
                              _c("v-simple-checkbox", {
                                attrs: { dense: "", disabled: "" },
                                model: {
                                  value: item.isAccountDisabled,
                                  callback: function($$v) {
                                    _vm.$set(item, "isAccountDisabled", $$v)
                                  },
                                  expression: "item.isAccountDisabled"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }